module.exports = __webpack_public_path__ + "img/xls.700b8bd9.png";